import { createUseStyles } from 'react-jss';

const useStyle = createUseStyles(() => ({
  enFont: {
    fontFamily: 'arial',
  },
  vehiclePlate: {
    display: 'inline-flex',
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
    border: 'solid 1px #a3a3a3',
    color: '#404040',
    fontSize: 18,
    borderRadius: 6,
    lineHeight: 1.1,
    fontWeight: 'bolder !important',
    overflow: 'hidden',
    userSelect: 'none',
    cursor: 'default',
    padding: '5px 0',
    textAlign: 'center',
    direction: 'ltr',
    '& .sep': {
      width: 1,
      height: 24,
      backgroundColor: '#a3a3a3',
    },
    '& .iran-id': {
      padding: '0 0.25em',
      '& .iran': {
        color: '#666',
        fontSize: 7,
        marginBottom: 2,
      },
    },
    '& .number-part': {
      display: 'inline-block',
      minWidth: 6,
      verticalAlign: 'middle',
    },
    '& .iran-flag': {
      borderRadius: 1,
      width: 14,
      display: 'inline-block',
      overflow: 'hidden',
      verticalAlign: 'middle',
      fontSize: 4,
      lineHeight: '3px',
      '& *': {
        height: 3,
        width: '100%',
        overflow: 'hidden',
      },
      '& .green': {
        backgroundColor: '#22a958',
      },
      '& .white': {
        color: '#989898',
      },
      '& .red': {
        backgroundColor: '#bd272d',
      },
    },
    '& .number': {
      padding: '0 0.25em',
      display: 'flex',
      flexDirection: 'row',
      direction: 'ltr',
      '& .character': {
        padding: '0 2px',
      },
    },
    '&.motorcycle .number': {
      flexDirection: 'column',
    },
    '&.motorcycle .iran-flag': {
      marginRight: 10,
    },
    '&:not(.motorcycle) .iran-flag': {
      width: 10,
      position: 'absolute',
      top: 3,
      left: 3,
      '& *': {
        height: 2,
      },
    },
    '&.freezone-old, &.freezone-new': {
      '& .number': {
        flexDirection: 'column',
      },
    },
    '& .freezone-img': {
      width: 14,
      padding: 2,
    },
  },
}));

export default useStyle;

